import { copyTextToClipboard } from 'mmfintech-commons'
import { useCallback, useEffect, useRef, useState } from 'react'

const COPIED_TOOLTIP_DURATION = 1000

// `copied` turns on only after the clipboard write succeeds; drives a controlled "Copied" tooltip
export const useCopyToClipboard = () => {
  const [copied, setCopied] = useState(false)
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => () => clearTimeout(hideTimeoutRef.current), [])

  const copy = useCallback((text: string) => {
    copyTextToClipboard(text, () => {
      clearTimeout(hideTimeoutRef.current)
      setCopied(true)
      hideTimeoutRef.current = setTimeout(() => setCopied(false), COPIED_TOOLTIP_DURATION)
    })
  }, [])

  return { copied, copy }
}
